// JS for Donate Init page

/* global Stripe, STRIPE_PUBLIC_KEY */
/* global grecaptcha, RECAPTCHA_KEY */

import { FormHelper } from "./webcomponents/form-helper.js";
import { TrainInfoCard } from "./webcomponents/train-info-card.js";
import { SubmitStatus } from "./webcomponents/submit-status.js";
import { PostJSON } from "./lib/fetchers.js";
import { SetElementsVisible, SetTextContent, WireupHandlers } from "./lib/data-wireup.js";

// Register required webcomponents
FormHelper.Register();
TrainInfoCard.Register();
SubmitStatus.Register();

let stripe = null;
let elements = null;
let page1Data = null;
let stripeRedirectUrl = null;
const stripeAppearance = {
    theme: "stripe",
    variables: {
        colorPrimary: "#042e53",
        colorBackground: "#ffffff",
        colorText: "#042e53",
        colorDanger: "#D22600",
        fontSizeBase: "16px",
        fontFamily: "Inter,Arial,sans-serif;",
        spacingUnit: "5px",
        borderRadius: "4px",
        fontLineHeight: "1.5"
    },
    rules: {
        ".Label": {
            color: "var(--colorPrimary)",
            fontWeight: "600",
            fontSize: "1rem",
            paddingBottom: "0.2rem",
        },
        ".Tab": {
            border: "1px solid rgba(48,54,95,.25)",
            boxShadow: "0",
        },
        ".Input": {
            border: "1px solid rgba(48,54,95,.25)",
            boxShadow: "0",
        },

        ".Tab:hover": {
            color: "var(--colorText)",
        },
        ".Input--invalid": {
            boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 0 0 1px var(--colorDanger)",
        }
    }
};
const currencyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

window.addEventListener("DOMContentLoaded", async () => {
    stripe = Stripe(STRIPE_PUBLIC_KEY);

    const formHelper = document.querySelector("form-helper");

    // Handle page 1 form submission rather than doing a POST
    formHelper.submitFunction = onPage1Submit;

    // Stick the custom amount in the right place
    formHelper.transformer = (formdata) => {
        if (formdata.donation && formdata.donation.Amount === "other") {
            formdata.donation.Amount = formdata.donation.Custom;
            delete formdata.donation.Custom;
        }
    };

    // Show/hide alert w/ anonymous checkbox
    WireupHandlers("anonymous", "click", async (e) => {
        SetElementsVisible("anonymous-alert", e.target.checked);
    });

    // Show/hide alert w/ anonymous checkbox
    WireupHandlers("donationamount", "click", async (e) => {
        SetElementsVisible("otheramount", e.target.value === "other");
    });

    // form-helper usually handles the sticky button bar, but we have a second one that needs an observer
    const el = document.querySelector(".page2-sticky-button-bar")
    if (el) {
        const page2Observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle("threshold-reached", e.intersectionRatio < 1),
            { threshold: [1] }
        );
        page2Observer.observe(el);
    }
});

window.onReCaptcha = function () {
    grecaptcha.render("recaptcha-container", {
        "sitekey": RECAPTCHA_KEY,
        "callback": onReCaptchaSubmit,
        "expired-callback": onReCaptchaExpire,
        "error-callback": onReCaptchaError,
        "size": "invisible"
    });
};

function onPage1Submit(data) {
    page1Data = data;
    stripeRedirectUrl = null;
    // Kick off captcha verification
    grecaptcha.execute();
}

function onReCaptchaExpire() {
    grecaptcha.reset();
    //SetLoadingState("emailsubmit", false);
    SubmitStatus.Hide("form-helper-status");
}


function onReCaptchaError() {
    grecaptcha.reset();
    //SetLoadingState("emailsubmit", false);
    SubmitStatus.Set("form-helper-status", "The action did not complete. Please try again.", true);
}

/**
 * On recaptcha success, submit the form, load stripe, and go to page 2
 */
async function onReCaptchaSubmit(token) {
    // Since this all happens outside of form-helper, manage the button state manually
    const submitButton = document.querySelector("[data-formhelper-submit-button]");
    submitButton.classList.add("button-loading");
    submitButton.setAttribute("disabled", "disabled");
    submitButton.innerText = "Processing";
    try {
        // Always reset the captcha in case they resend or go back and send to another email
        grecaptcha.reset();
        if (!page1Data) {
            console.error("Recaptcha success but no page 1 data");
            return;
        }
        page1Data.token = token;
        const result = await PostJSON("", page1Data);
        stripeRedirectUrl = result.redirectUrl;
        elements = stripe.elements({ clientSecret: result.key, appearance: stripeAppearance, loader: "always" });
        var paymentElement = elements.create("payment", {
            fields: {
                billingDetails: {
                    email: "never"
                }
            }
        });
        paymentElement.mount("#payment-element");
        SetTextContent("total", currencyFormatter.format(page1Data.donation.Amount));
        SubmitStatus.Hide("page2-status");
        SetElementsVisible("page1", false);
        SetElementsVisible("page2", true);
    } catch (err) {
        console.error(err);
        SubmitStatus.Set("form-helper-status", err.message, true);
    } finally {
        submitButton.classList.remove("button-loading");
        submitButton.removeAttribute("disabled");
        submitButton.innerHTML = "Next";
    }
}

WireupHandlers("page2-back", "click", async () => {
    SetElementsVisible("page1", true);
    SetElementsVisible("page2", false);
});

WireupHandlers("page2-submit", "click", async () => {
    SubmitStatus.Hide("page2-status");
    try {
        if (!elements || !stripeRedirectUrl || !page1Data) {
            // Something is wrong, go back to page 1
            console.error("Stripe elements, redirect url, or page 1 data missing");
            SetElementsVisible("page1", true);
            SetElementsVisible("page2", false);
            return;
        }
        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: stripeRedirectUrl,
                payment_method_data: {
                    billing_details: {
                        email: page1Data.donation.Email,
                    },
                },
            },
        });
        // Stripe doesn't throw errors on failures, so we have to check the result
        if (result.error) throw new Error(result.error.message);
    } catch (err) {
        console.error(err);
        SubmitStatus.Set("page2-status", err.message, true);
    }
});